<script>
export default {
  name: 'GuardianNav',
  data () {
    return {
      navGroups: [
        {
          links: [
            {
              icon: 'house',
              title: 'Dashboard',
              route: 'GuardianDashboard',
            },
          ],
        },
      ],
    }
  },
}
</script>

<template lang="pug">
  .guardian-nav-main.side-nav-main
    .guardian-nav-container.side-nav-container
      .link-groups-holder
        .link-group(
          v-for='group in navGroups'
        )
          router-link.link(
            v-for='(link, idx) in group.links'
            :key='idx'
            :to='{name: link.route}'
            :class='$route.name === link.route ? `chosen`: ``'
          )
            .icon
              i.material-icons.outline {{link.icon}}
            .title {{link.title}}
</template>

<style lang="sass" scoped>
  @import '$styles/side-nav'
  @media(max-width:700px)
    .guardian-nav-main
      display: none

</style>